import { InjectionToken } from '@angular/core';

export const AUTH_SERVER_TOKEN = new InjectionToken<string>('AuthServer');
